import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { compose, lifecycle } from 'recompose';

import authHOC from '../Components/AuthHOC';
import AssessmentsView from './Components/AssessmentsView';

import {
  getClientBackGroundRequest,
  toggleSaveEditPopup,
  toggleUserDashboard,
  toggleRefererPage,
} from '../redux/reducers/view';
import { authAdminRequest, authUserRequest, getTokenFromCookies } from '../redux/reducers/login';
import {
  getUserProgramsFullRequest,
  selectUserPrograms,
  selectUserModule,
} from '../redux/reducers/userProgramsFull';

import { withRouter } from 'react-router-dom';
import { assessmentsListRequest } from '../redux/reducers/contentList';
import { dropdownsRequest } from '../redux/reducers/dropdowns';

const Assessments = ({ view }) => <AssessmentsView view={view} />;

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  view: state.viewReducer,
  savedVersions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
  contentList: state.contentListReducer
});

const mapDispatchToProps = dispatch => ({
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  getClientBackGroundRequest: () => dispatch(getClientBackGroundRequest()),
  toggleSaveEditPopup: value => dispatch(toggleSaveEditPopup(value)),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  toggleUserDashboard: value => dispatch(toggleUserDashboard(value)),
  selectUserPrograms: programId => dispatch(selectUserPrograms(programId)),
  selectUserModule: moduleId => dispatch(selectUserModule(moduleId)),
  toggleRefererPage: moduleId => dispatch(toggleRefererPage(moduleId)),
  getAssessmentsList:() => dispatch(assessmentsListRequest()),
  dropdownsRequest: () => dispatch(dropdownsRequest()),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  authHOC,
  lifecycle({
    componentWillMount() {
      const {
        loginReducer,
        getClientBackGroundRequest,
        view,
        savedVersions,
        toggleSaveEditPopup,
        contentList,
        getUserProgramsFullRequest,
        toggleUserDashboard,
        getAssessmentsList,
      } = this.props;
      const isLoggedIn = loginReducer.user && loginReducer.user.userId;

      
      if (isLoggedIn && contentList.isFetched === false) {
        getAssessmentsList();
      }
    
      toggleUserDashboard(false);
    },
    componentWillReceiveProps(nextProps) {
      const {
        loginReducer,
        getClientBackGroundRequest,
        view,
        contentList,
        getAssessmentsList,
        selectUserPrograms,
        // selectUserModule,
      } = nextProps;
      const isLoggedIn = loginReducer.user && loginReducer.user.userId;
     
      if (
        isLoggedIn &&
        contentList.isFetchedAssessments === false &&
        contentList.isFetchingAssessments === false
      ) {
        getAssessmentsList();
      }
      // if(contentList.isFetchedAsssessments === true && contentList.fetching===false && isLoggedIn){
      //   selectUserPrograms(nextProps.match.params.programId)
      //   getAssessmentsList();
      // }
      // if (userProgramsFull.isFetched && userProgramsFull.selectedProgramId === null) {
      //   selectUserPrograms(userProgramsFull.programs.programs[0].programId);
      //   // selectUserModule(userProgramsFull.programs.programs[0].modules[0].moduleId);
      // }
    },
  }),
 
)(Assessments);

Assessments.propTypes = {
  view: PropTypes.instanceOf(Object),
};
